import React, { useState } from 'react';
import LogoHeader from '../Componentes/LogoHeader';
import Footer from '../Componentes/Footer';
import ImagemDiv from '../Componentes/ImagemDiv';
import { useNavigate } from 'react-router-dom';
import BotaoDuplo from '../Componentes/BotaoDuplo';
import TextInput from '../Componentes/TextInput';
import Modal from '../Componentes/Modal';
import { apiService } from '../Services/ApiService';
import ModalConfirmacao from '../Componentes/ModalConfirmacao';

export default function SenhaReset() {
  const navigate = useNavigate();
  const [erroEmail, setErroEmail] = useState(false);
  const [emailTexto, setEmailTexto] = useState('');
  const [emailErroTexto, setEmailErroTexto] = useState('');
  const [modalSuccess, setModalSuccess] = useState({
    isVisible: false,
    message: '',
  });
  const { post } = apiService();

  const handleEnviarLink = async () => {
    if (emailTexto.trim() === '') {
      setEmailErroTexto('Este campo precisa ser preenchido');
      setErroEmail(true);
      return;
    }

    try {
      const response = await post('auth/forgot-password', { email: emailTexto });
      if (response) {
        setModalSuccess({
          isVisible: true,
          message: 'Recuperação de senha enviada! Verifique seu e-mail.',
        });
        setEmailTexto('');
      }
    } catch (error) {
      setEmailErroTexto('E-mail não está cadastrado no sistema');
      setErroEmail(true);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      {modalSuccess.isVisible && (
        <ModalConfirmacao
        aviso={modalSuccess.message}
        confirmar={true}
        clicado={() => setModalSuccess({ isVisible: false, message: '' })}
      />
      )}

      <div className="CorpoLogin">
        <div className="AreaLogin">
          <div className="AreaLoginInterna">
            <LogoHeader />

            <h3
              id="TituloLogin"
              style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: 20 }}
            >
              RECUPERAR SENHA
            </h3>

            <p id="TextoDescritivo">
              Insira seu e-mail no campo abaixo para lhe enviarmos um link de recuperação de senha.
            </p>

            <TextInput
              titulo="E-mail"
              tipo="email"
              placeholder="Insira o e-mail cadastrado"
              erro={erroEmail}
              erroTexto={emailErroTexto}
              padrao={emailTexto}
              onUpdate={(txt) => setEmailTexto(txt)}
            />

            <BotaoDuplo nome="Enviar Link" nomeVolta="Voltar" top={64} clicado={handleEnviarLink} />

            <div style={{ marginTop: 88 }}></div>

            <Footer />
          </div>
        </div>

        <ImagemDiv />
      </div>
    </div>
  );
}
